import React from "react";
import { Image } from "react-bootstrap";

//COMPONENTS
import * as CurrencyMethods from "../../../../admin/files/currencyMethods";

//STYLES
import * as ItemStyles from "../styles/product";

function Product(props) {
    const browserDisplay = (
        <div style={ItemStyles.innerBody} onClick={props.click.bind(this, props.product.productCode)}>
            <p style={ItemStyles.title}>{props.product.title}</p>
            <Image src={`/content/3dPrintingShop/products/${props.product.uuid.toString()}/${props.product.mainImage}`} style={ItemStyles.image} />
            <p style={ItemStyles.price}>{`Price: £${CurrencyMethods.FormatCurrency(props.product.price)}`}</p>
            <p style={ItemStyles.price}>{`Product Code: ${props.product.productCode}`}</p>
        </div>
    );

    const mobileDisplay = (
        <div style={ItemStyles.mobile_innerBody} onClick={props.click.bind(this, props.product.productCode)}>
            <p style={ItemStyles.title}>{props.product.title}</p>
            <Image src={`/content/3dPrintingShop/products/${props.product.uuid.toString()}/${props.product.mainImage}`} style={ItemStyles.image} />
            <p style={ItemStyles.price}>{`Price: £${CurrencyMethods.FormatCurrency(props.product.price)}`}</p>
            <p style={ItemStyles.price}>{`Product Code: ${props.product.productCode}`}</p>
        </div>
    );

    return <div>{props.mobile ? mobileDisplay : browserDisplay}</div>;
}

export default Product;
